/**
 * Kill switch for the partner scheduled-export history page (RFC 080). Set true
 * in every environment block of `config/environment.js`; flipping it false makes
 * the route guard bounce to the reports index and hides the entry link.
 */
export const SCHEDULED_EXPORTS_FEATURE_FLAG = 'reportingScheduledExports';
